import groq from "groq"

import { groqArticleProjection } from "../../shared/sanity/article.projection"

export const specialOfferProjection = () => groq`
  id,
  activeFrom,
  activeUntil,
  "appliedToBundles": bundles[]->{
    "id": _id,
        "type": _type,
        title,
        altTitle,
        image,
        descriptionBlocks,
        attachment{
          label,
          file{
            asset->{url, originalFilename}
          }
       },
        variants[]->{
              ...,
            ${groqArticleProjection()}
        }
  },
  appliedToVariants[]->{
    ...,
    articleMainGroup-> {
        "id": _id,
        key,
        name,
    },
    articleGroup-> {
        "id": _id,
        key,
        name,
    },
    "productRef": *[_type=="product" && references(^._id)][0] {
      _id,
      title,
      key,
      title,
      "images": attachments[type=="img"] {...,asset->},
  }
  },
  appliesToAllArticle,
  "attachmentImages": attachments[_type=="image"] {
    ...,
    asset-> {
      _id,
      metadata {
        lqip
      }
    }                        
  },
  "attachmentFiles": attachments[_type=="file"].asset->{
    url,
    originalFilename,
  },
  creationAt,
  modifiedAt,
  name,
  targetContainer,
  visibleUserGroups,
  visibleEmployees[]->{"admNumber": key},
`
